export default "__VITE_ASSET__ac58bfe4__"